import { render, staticRenderFns } from "./airdrop.vue?vue&type=template&id=523538a4&scoped=true"
import script from "./airdrop.vue?vue&type=script&lang=js"
export * from "./airdrop.vue?vue&type=script&lang=js"
import style0 from "./airdrop.vue?vue&type=style&index=0&id=523538a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523538a4",
  null
  
)

export default component.exports